import React from "react";
import FormRegisterLanding from "components/formRegisterLanding/formRegisterLanding";

const RegisterLanding = () => <FormRegisterLanding />;

export default RegisterLanding;
